// import { Input } from 'antd';
import React from 'react';
import _ from "lodash"
import * as Yup from 'yup';
import { Formik, useFormik } from 'formik';
import {constants} from "../CRM/constants";
import "./Select.css"
import { Select} from "antd";
const { Option } = Select;

export default function SelectInput(props) {
  const id = JSON.stringify(props.id);

    return (
    <div 
    style ={{marginTop : 20}}
    >
          <div 
          style = {{position :"relative"}}
          >
     
        <Select
            autoClearSearchValue={true}
            onChange = {props.handleChange(id)}
            value = {props.values[props.id] || null}
            placeholder ={props.name}
            // showSearch={true}
            style={{width:"80%",height : 45,fontSize : 14,
            marginLeft : 15,marginRight : 15,
            borderWidth : 1,
            borderRadius : 5,
          }}
            onBlur={props.handleBlur(id)}
          >
            {_.map(constants?.occupation,(item,index)=>{
                return  <Option  key={index} value={item.value} >{item.label}</Option>
            }
            )}
             
        </Select>
           
		
        </div>
    </div>
  )
}
